import { useDispatch, useSelector } from "react-redux";
import { setCurrency } from "./reducers/currencyReducer"

const currencies = ["PLN", "EUR", "USD"];

const CurrencySwitcher = () => {
    const dispatch = useDispatch();
    const selectedCurrency = useSelector(state => state.currency.selectedCurrency);

    return (
        <select
            value={selectedCurrency}
            onChange={e => dispatch(setCurrency(e.target.value))}
        >
            {currencies.map(c => (
                <option value={c} key={c}>{c}</option>
            ))}
        </select>
    );
};

export default CurrencySwitcher;
